import { createFileRoute } from '@tanstack/react-router';
import { CapabilityTier } from '@signalvote/shared';
import { requireCapability } from '@/lib/routeGuards';
import { FundraisingLayout } from '@/components/fundraising';

// The Fundraising area: paywalled like the /app modules. Each page under it carries its own tier gate;
// this one admits anyone who can see Fundraising at all.
export const Route = createFileRoute('/admin/fundraising')({
  beforeLoad: ({ context }) => {
    requireCapability(context, 'Fundraising', CapabilityTier.View, '/admin/fundraising');
  },
  component: FundraisingLayout,
});
